import axios from './axios';

export const createAComment = data => axios.post('/comments/create-comment', data);

export const getComments = videoId => axios.get(`/comments/${videoId}`);

export const deleteComment = id => axios.delete(`/comments/delete-comment/${id}`);

export const getCommentsCount = id => axios.delete(`/comments/comment-count/${id}`);
